const currencySymbolMap = new Map();
// America
currencySymbolMap.set('USD', '$'); // US Dollar
currencySymbolMap.set('CRC', '₡'); // Costa Rican Colón
currencySymbolMap.set('PYG', '₲'); // Paraguayan Guarani

// Europe
currencySymbolMap.set('EUR', '€'); // Euro
currencySymbolMap.set('GBP', '£'); // British Pound Sterling
currencySymbolMap.set('PLN', 'zł'); // Polish Zloty
currencySymbolMap.set('UAH', '₴'); // Ukrainian Hryvnia

// Africa
currencySymbolMap.set('NGN', '₦'); // Nigerian Naira

// Asia
currencySymbolMap.set('THB', '฿'); // Thai Baht
currencySymbolMap.set('PHP', '₱'); // Philippine Peso
currencySymbolMap.set('VND', '₫'); // Vietnamese Dong
currencySymbolMap.set('ILS', '₪'); // Israeli New Sheqel
currencySymbolMap.set('INR', '₹'); // Indian Rupee
currencySymbolMap.set('JPY', '¥'); // Japanese Yen
currencySymbolMap.set('KRW', '₩'); // South Korean Won
currencySymbolMap.set('MYR', 'M$'); // Malaysian Ringgit
currencySymbolMap.set('QAR', 'QR'); // Qatari Rial

export function formatCurrency(currencyCode) {
  if (currencyCode === 'USD') return '$';
  return currencyCode;
}
export function formatCurrencyWithSymbol(currencyCode) {
  const currencySymbol = currencySymbolMap.get(currencyCode);
  return currencySymbol || currencyCode;
}

function formatDecimals(value, digits = 2) {
  return (Math.round(value * 100) / 100).toFixed(digits);
}

export function formatPrice({ amount = 0, currencyCode = 'USD' }) {
  return `${formatCurrency(currencyCode)}${formatDecimals(amount)}`;
}

export function formatPriceWitheCurrencySymbol({ amount = 0, currencyCode = 'USD' }) {
  return `${formatCurrencyWithSymbol(currencyCode)}${formatDecimals(amount)}`;
}

// Remove trailing zeros and hyphens
export function attendeeUIdZerosRemover(value) {
  if (value.length === 32) {
    return value.replace(/-0+$/, '');
  }
  return value;
}
